<template lang="html">
  <v-container mt-5>
    <div class="text-xs-center mb-5" v-if="loading">
      <v-progress-circular
      indeterminate
      color="primary"
      ></v-progress-circular>
    </div>
    <v-layout row wrap>
      <v-flex
        xs12
        md10 offset-md1
        xl8 offset-xl2
      >
        <v-subheader>Widgets</v-subheader>
      </v-flex>
      <v-flex
        xs12
        md10 offset-md1
        xl8 offset-xl2
      >
        <v-card>
          <v-img
            height="150px"
            src="https://source.unsplash.com/bphc6kyobMg/1600x900"
          >
            <v-container fill-height fluid text-xs-left>
              <v-layout fill-height>
                <v-flex xs12 align-end flexbox>
                  <span class="headline white--text">Lead Scoring Engine</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-img>
          <v-card-text class="text-xs-left">
            Use the lead scoring engine to quickly qualify your leads. Once you have a score, enter it into Zoho so you may sort your leads at a glance.
          </v-card-text>
          <v-card-actions>
            <sp-lead-scoring-engine></sp-lead-scoring-engine>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex
        xs12
        md10 offset-md1
        xl8 offset-xl2
      >
        <v-subheader>Forms</v-subheader>
      </v-flex>
      <v-flex
        xs12
        md10 offset-md1
        xl8 offset-xl2
      >
        <sp-forms></sp-forms>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Forms from './Forms/Forms.vue'
import LeadScoringEngine from './LeadScoringEngine/LeadScoringEngine'
import {mapState, mapGetters} from 'vuex'
export default {
  data () {
    return {
      snackbar: false
    }
  },
  methods: {
    copyToClipBoard (str) {
      const el = document.createElement('textarea')
      el.value = str
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.snackbar = true // notifiy user
    }
  },
  computed: {
    ...mapState('tools/forms/', [
      'forms'
    ]),
    ...mapGetters({
      loading: 'loading'
    })
  },
  mounted () {
    // fetch the forms from firebase
    this.$store.dispatch('tools/forms/fetchForms')
  },
  components: {
    'SpForms': Forms,
    'SpLeadScoringEngine': LeadScoringEngine
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/pages/Tools/Tools.vue